import { IEditor, EditorPlugin } from 'roosterjs-editor-types';
import getUserOptions from 'owa-proofing-option/lib/selectors/getUserOptions';
import { isProofingSupported } from 'owa-editor-proofing-common';
import { isProofingSupportLocale } from 'owa-proofing-option/lib/utils/isProofingSupportLocale';

export default class SpellcheckPlugin implements EditorPlugin {
    private editor: IEditor;

    public getName() {
        return 'spellcheckPlugin';
    }

    public initialize(editor: IEditor): void {
        this.editor = editor;
        if (this.editor) {
            if (isProofingSupported()) {
                getUserOptions(userOptions => {
                    if (
                        isProofingSupportLocale(userOptions?.proofingLocale) &&
                        (userOptions?.spellCheckEnabled || userOptions?.grammarEnabled)
                    ) {
                        this.editor.setEditorDomAttribute('spellCheck', 'false');
                    }
                });
            }
        }
    }

    public dispose(): void {
        this.editor = null;
    }
}
